module.exports = __webpack_public_path__ + "img/tick-icon.c3cd2b60.svg";